import {Component, Injector, OnInit, TemplateRef, ViewChild, ViewEncapsulation, ChangeDetectionStrategy} from "@angular/core";
import {ActivatedRoute, Router} from '@angular/router';
import {SideMenuService} from "../../../services/side-menu.service";
import {ClaimTypeItem} from "../../../model/claim-type-item.model";
import {TransactionInfoService} from "../../../services/transaction-info.service";
import {ClaimsBaseComponent} from "../../../claim-pages/claim-base.component";
import {Notifications} from "../../../utilities/components/notification-messages/notifications.model";
import {ClaimTypes} from "../../../model/claim-type.model";
import {DocumentHelperService} from "../../../services/document-helper.service";
import {TransactionInfo} from "../../../model/transaction-info.model";
import {DynamicRoutingService} from "src/app/services/dynamic-routing.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {UtilitiesService} from "src/app/utilities/utilities.service";
import {
    EcFormSelectionModalComponent
} from "src/app/utilities/components/ec-form-selection-modal/ec-form-selection-modal";
import {ClaimTypeItemHelperService} from "src/app/services/claim-type-item-helper.service";

@Component({
    selector: 'app-select-claim',
    templateUrl: './select-claim.component.html',
    styleUrls: ['./select-claim.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectClaimComponent extends ClaimsBaseComponent implements OnInit {
    public claimTypeData: ClaimTypeItem[];
    public chooseIndex: number;
    public selectedClaimCode: string = '';
    public menu: any;
    public limit = {ClaimTypeId: null};
    public nextLinkUrl: string = '';
    showTotalBox = false;
    notifications: Notifications = new Notifications();
    hasActiveClaimType: boolean = false;
    transactionInfo: TransactionInfo;
    closeAlert: boolean = false;
    disruptedSubGroup: any = [];
    otherSubGroup: any = [];
    isExpanded: boolean = false;
    disableAllTypes: boolean = false;
    isTravel:boolean = false;
    isHome:boolean = false;

    alertClaimTypeModalRef: any;
    @ViewChild('alert_claim_type', {static: true}) alertClaimTypeModal: TemplateRef<any>;

    @ViewChild('ec_form_selection_modal', {static: true}) 
    formSelectionModal: EcFormSelectionModalComponent;

    @ViewChild('confirm_delete_claim_type', {static: true}) deleteClaimTypeModal: TemplateRef<any>;
    deleteClaimTypeModalRef: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private sideMenuService: SideMenuService,
                private transactionInfoService: TransactionInfoService,
                private documentHelperService : DocumentHelperService,
                private dynamicRoutingService: DynamicRoutingService,
                private modalService: NgbModal,
                private claimTypeItemHelperService: ClaimTypeItemHelperService,
                private injector : Injector) {

        super(injector);
        this.transactionInfo = this.transactionInfoService.getTransactionInfo();
    }

    ngOnInit() {
        this.pushGASelectClaimView();
        this.claimTypeData = this.transactionInfo.getClaimTypeItemList();
        this.isTravel = this.transactionInfo.isTravelProduct();
        this.isHome = this.transactionInfo.isHomeProduct();

        if (this.transactionInfo.isTravelProduct()) {
            this.buildTravelSubGroup();

            this.disableAllTypes = this.transactionInfo
                .getNavigationMenu()
                .getClaimDetailMenu()
                .some(menuItem =>
                    !menuItem.hidden && menuItem.subMenus?.some(subMenu => !subMenu.hidden && !subMenu.complete));
        }

        setTimeout(() => {
            this.showSvgPath();
        }, 10);
    }

    toggleActive(claimTypeId, claimType: ClaimTypeItem, subGroup?: any) {
        if (claimType.disabled) {
            return;
        }

        this.chooseIndex = claimTypeId;
        this.selectedClaimCode = claimType.claimTypeCode;
        this.hasActiveClaimType = true;
    
        if (this.transactionInfo.isTravelProduct() && this.claim.getSelectedClaimTypesList()?.length > 0) {
            const swappingTypes = [ClaimTypes.CLAIM_TYPE_CAN,ClaimTypes.CLAIM_TYPE_CAN_CRTL,ClaimTypes.CLAIM_TYPE_CAN_RROUT,ClaimTypes.CLAIM_TYPE_TDEL];
            const removedSwappingTypes = this.claim.getSelectedClaimTypesList().filter(name => !swappingTypes.includes(ClaimTypes[name as keyof typeof ClaimTypes]));

            if (this.disableAllTypes) {
                if (!this.isTravelDelayedReroutedOrTripCancelledCurtailedSelected(claimType.claimTypeCode)) {
                    this.clearSelection();
                    return;
                }

                for (const claimType of this.transactionInfo.getClaimTypeItemList()) {
                    if (removedSwappingTypes.includes(claimType.claimTypeCode)) {
                        for (const menu of this.transactionInfo.getNavigationMenu().getClaimDetailMenu()) {
                            if (claimType.claimTypeId === menu.claimTypeId && menu.subMenus.some(subMenu => !subMenu.hidden && !subMenu.complete)) {
                                this.clearSelection();
                                return;
                            }
                        }
                    }
                }
            }
            // update isActive from disrupteSubGroup or otherSubGroup based on which group the claimType belongs to
            if (subGroup) {
                subGroup.isActive = subGroup.claimTypeData.some(data => data.claimTypeId === claimTypeId);
            }
            if (this.claim.getSelectedClaimTypesList()?.length > 0) {
                this.handleTravelProduct();
            }
        } else if (this.transactionInfo.isDomesticHelperProduct() && claimType.claimTypeCode == ClaimTypes[ClaimTypes.CLAIM_TYPE_UNKNOWN]) {
            this.handleDomesticHelperProduct();
        } else if (this.transactionInfo.isMotorProduct()) {
            this.handleMotorProduct();
        } else if (this.transactionInfo.isHomeProduct() || this.transactionInfo.isDomesticHelperProduct() || this.transactionInfo.isEmployeeCompensationProduct()) {
            this.handleHomeDomesticEmployeeProduct(claimType);
        } else if (this.transactionInfo.isAccidentProduct()) {
            this.handleAccidentProduct(claimType);
        }
    }

    private clearSelection(){
        this.chooseIndex = undefined;
        this.selectedClaimCode = '';
        this.hasActiveClaimType = true;
    }

    private handleTravelProduct() {
        if (this.isTravelDelayedReroutedOrTripCancelledCurtailedSelected(this.selectedClaimCode)) {
            this.openDeleteClaimTypePopup();
        }
    }

    private isTravelDelayedReroutedOrTripCancelledCurtailedSelected(claimCode: string): boolean {
        const isClaimTypeSelected = (type1: string, type2: string): boolean =>
            claimCode === type1 &&
            this.claim.getSelectedClaimTypesList().includes(type2);
        const travelDelayedRerouteSelected = isClaimTypeSelected(ClaimTypes[ClaimTypes.CLAIM_TYPE_TDEL], ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_RROUT]) ||
            isClaimTypeSelected(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_RROUT], ClaimTypes[ClaimTypes.CLAIM_TYPE_TDEL]);

        const tripCancellationCurtailmentSelected = isClaimTypeSelected(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN], ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_CRTL]) ||
            isClaimTypeSelected(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_CRTL], ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN]);

        return travelDelayedRerouteSelected || tripCancellationCurtailmentSelected;
    }
    
    private handleDomesticHelperProduct() {
        this.claimTypeData[2]['show'] = false;
        for (let i = 3; i < this.claimTypeData.length; i++) {
            this.claimTypeData[i]['show'] = true;
        }
        this.selectedClaimCode = '';
        this.hasActiveClaimType = false;
    }
    
    private handleMotorProduct() {
        if (this.claim.getSelectedClaimTypesList().length > 0) {
            this.chooseIndex = undefined;
            this.selectedClaimCode = '';
            this.hasActiveClaimType = true;
        }
    }
    
    private handleHomeDomesticEmployeeProduct(claimType: ClaimTypeItem) {
        if (this.claim.getSelectedClaimTypesList().length > 0) {
            if(this.transactionInfo.isHomeProduct() && claimType.claimTypeCode !== this.claim.getSelectedClaimTypesList()[0]){
                this.openDeleteClaimTypePopup();
            }else{
                this.chooseIndex = undefined;
                this.selectedClaimCode = '';
                this.hasActiveClaimType = true;
            }
        }
        this.setGAClaimType(claimType);
    }
    
    private handleAccidentProduct(claimType: ClaimTypeItem) {
        if (this.claim.getSelectedClaimTypesList().length > 0) {
            if (claimType.claimTypeCode !== this.claim.getSelectedClaimTypesList()[0]) {
                this.openDeleteClaimTypePopup();
            } else {
                this.chooseIndex = undefined;
                this.selectedClaimCode = '';
                this.hasActiveClaimType = true;
            }
        }
        this.setGAClaimType(claimType);
    }

    goToNext() {
        this.notifications.clearMessages();
        const selectedClaimItemList: string[] = this.claim.getSelectedClaimTypesList();
        let oneSelected: boolean = false;

        //check if no active selected claim type, set the current to last entry in select claim type list
        if (this.claim.getSelectedClaimTypesList().length > 0 && this.chooseIndex == undefined) {
            if (this.transactionInfo.isDomesticHelperProduct() && !this.closeAlert) {
                this.openAlertModal();
                return false;
            } else {
                oneSelected = this.getCurrentClaimType();
            }
        } else {
            if (this.hasActiveClaimType) {
                let claimTypeSelected =  this.claimTypeData.find(claimTypeItem =>
                    claimTypeItem.claimTypeCode === this.selectedClaimCode);
                if (!UtilitiesService.isNullOrUndefined(claimTypeSelected)) {
                    claimTypeSelected.selected = true;
                    if (selectedClaimItemList.indexOf(claimTypeSelected.claimTypeCode) < 0) {
                        selectedClaimItemList.push(claimTypeSelected.claimTypeCode);
                    } else {
                        if (this.transactionInfo.isDomesticHelperProduct() && !this.closeAlert) {
                            this.openAlertModal();
                            return false;
                        }
                    }
                }
                oneSelected = true;
            }
        }

        if (oneSelected) {
            //get claim type menu from transaction info
            let claimTypeDetailMenu = this.transactionInfo.getNavigationMenu().getClaimDetailMenu();
            if (Object.keys(claimTypeDetailMenu[this.chooseIndex]['subMenus']).length !== 0) {
                this.claim.setSelectedClaimTypesList(selectedClaimItemList);
                this.transactionInfoService.getTransactionInfo().setClaimTypeItemList(this.claimTypeData);
                this.sideMenuService.emitCliamType(this.chooseIndex);
                this.sideMenuService.emitComplete('finishDetail');
                this.sideMenuService.emitProgress(1);

                this.limit = { ClaimTypeId: this.chooseIndex };

                if (this.transactionInfo.isAccidentProduct() && (this.claim.isHKGorHGI() ||
                    (this.claim.isSGP() && claimTypeDetailMenu[this.chooseIndex]['url'] != undefined))) {
                    this.nextLinkUrl = claimTypeDetailMenu[this.chooseIndex]['url'];
                } else {
                    this.nextLinkUrl = claimTypeDetailMenu[this.chooseIndex]['subMenus'][0]['url'];
                }
                this.router.navigate([this.nextLinkUrl]);

                //set document form builder of selected claim type
                if (this.selectedClaimCode !== '' && this.hasActiveClaimType) {
                    if (this.transactionInfo.isHomeProduct()) {
                        this.transactionInfo.setDynamicRoutes(this.dynamicRoutingService.getDynamicHomeRoutes(this.selectedClaimCode));
                    } else {
                        this.documentHelperService.addDocumentFormBuilder(this.selectedClaimCode);
                    }
                }
            }
        } else {
            this.displayNotificationMsg("error_messages.notificationsErrMsg.claimType");
        }

    }

    displayNotificationMsg(errorMsg: string) {
        this.notifications = new Notifications();
        this.notifications.showPreamble = false;
        this.notifications.addErrorMessage(errorMsg);
        this.scrollToTop();
    }

    getCurrentClaimType() : boolean {
       let currentClaimType = this.transactionInfo.getCurrentClaimType();
         if (this.isNotNullOrUndefinedStr(currentClaimType) && (this.chooseIndex == undefined || this.hasActiveClaimType)) {
             let currentClaimTypeSelected =  this.claimTypeData.find(claimTypeItem =>
                 claimTypeItem.claimTypeCode === currentClaimType);
             if(!UtilitiesService.isNullOrUndefined(currentClaimTypeSelected)) {
                 this.chooseIndex = currentClaimTypeSelected.claimTypeId;
                 this.selectedClaimCode = currentClaimTypeSelected.claimTypeCode;
                 return true;
             }
         }
       return false;
    }

    showModal() {
        this.showTotalBox = true;
    }

    getData(msg) {
        this.showTotalBox = msg;
    }

    back() {
        this.sideMenuService.emitProgress(-1);
        if (this.transactionInfo.isMotorProduct()) {
            this.router.navigate(["/claimform/confirmVehicleDetails"], {
                relativeTo: this.activatedRoute
            });
        } else if (this.transactionInfo.isHomeProduct()) {
            this.router.navigate(["/claimform/confirmIncidentDetails"], {
                relativeTo: this.activatedRoute
            });
        } else if (this.transactionInfo.isAccidentProduct()) {
            this.router.navigate(['/claimform/paDetailsOfAccident'], {
                relativeTo: this.activatedRoute
            });
        } else if (this.transactionInfo.isEmployeeCompensationProduct()) {
            this.router.navigate(["/claimform/employerDetails"], {
                relativeTo: this.activatedRoute
            });
        }else if (this.transactionInfo.hasSingleInsured()) {
            this.router.navigate(["/claimform/confirmTravelPeriod"], {
                relativeTo: this.activatedRoute
            });
        } else {
            this.router.navigate(["/claimform/selectInsured"], {
                relativeTo: this.activatedRoute
            });
        }
    }

    buildTravelSubGroup() {
        const group = this.getSubGroup(this.claimTypeData);

        const disruptedSubGroup = [
            'claimDetails.claimTypeName.travelInconvenienceDisruption',
            'claimDetails.claimTypeName.cancelledShortenedTrip'
        ];

        const otherSubGroup = [
            'claimDetails.claimTypeName.lossOrDamage',
            'claimDetails.claimTypeName.sicknessOrInjury',
            'claimDetails.claimTypeName.otherIncidents'
        ];

        const filterAndSortGroup = (order: string[]) =>
            group?.filter(c => order.includes(c.claimTypeGroupName))
                .sort((a, b) => order.indexOf(a.claimTypeGroupName) - order.indexOf(b.claimTypeGroupName));

        this.disruptedSubGroup = filterAndSortGroup(disruptedSubGroup);
        this.otherSubGroup = filterAndSortGroup(otherSubGroup);

        if (this.disruptedSubGroup.find(group => group.claimTypeData.some(data => data.selected))) {
            this.isExpanded = true;
        }
    }

    getSubGroup(data: any[]): any[] {
        const groupNameMap = {
            DISRUPTION_DELAYED_REROUTE: {
                name: 'claimDetails.claimTypeName.travelInconvenienceDisruption',
                description: 'claimDetails.claimTypeName.transWasDelayedRerouted'
            },
            DISRUPTION_CANCEL_CURTAIL: {
                name: 'claimDetails.claimTypeName.cancelledShortenedTrip',
                description: 'claimDetails.claimTypeName.cancelTripEarly'
            },
            LOSS_OR_DAMAGE: {
                name: 'claimDetails.claimTypeName.lossOrDamage',
                description: 'claimDetails.claimTypeName.issueWithLuggageOrBelongings'
            },
            SICKNESS_OR_INJURY: {
                name: 'claimDetails.claimTypeName.sicknessOrInjury',
                description: 'claimDetails.claimTypeName.needsMedicalCare'
            },
            OTHERS: {
                name: 'claimDetails.claimTypeName.otherIncidents',
                description: 'claimDetails.claimTypeName.otherIncident'
            },
        };

        const tempMap: Record<string, any> = {};

        data.forEach(item => {
            const group = item.group;
            const claimTypeCode = item.claimTypeCode;
            const groupInfo = groupNameMap[group] || {};
            const claimTypeGroupName = groupInfo.claimType?.[claimTypeCode] ?? groupInfo.name;
            const key = `${group}_${claimTypeGroupName}`;

            if (!tempMap[key]) {
                tempMap[key] = {
                    group,
                    description: groupInfo.description,
                    isExpanded: false,
                    isActive: false,
                    claimTypeGroupName,
                    claimTypeGroupClassName: claimTypeGroupName?.replace('claimDetails.claimTypeName.', ''),
                    claimTypeData: []
                };
            }

            if (item.selected) {
                tempMap[key].isExpanded = true;
                tempMap[key].isActive = true;
            }

            tempMap[key].claimTypeData.push(item);
        });

        return Object.values(tempMap);
    }

    toggleAccordion(group){
        group.isExpanded = !group.isExpanded;
    }

    toggleIncAccordion(){
        this.isExpanded = !this.isExpanded;
    }

    scrollToTop() {
        (function smoothScroll() {
            const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            if (currentScroll > 2) {
                window.requestAnimationFrame(smoothScroll);
                window.scrollTo(0, currentScroll - (currentScroll / 5));
            }
        })();
    }

    openAlertModal() {
        this.alertClaimTypeModalRef = this.modalService.open(this.alertClaimTypeModal, {size: 'sm',
            backdrop: 'static',
            keyboard: false
        });
    }

    continue() {
        this.closeAlert = true;
        this.alertClaimTypeModalRef.close();
    }

    openDeleteClaimTypePopup() {
        this.deleteClaimTypeModalRef = this.modalService.open(this.deleteClaimTypeModal, {size: 'md',
            backdrop: 'static',
            keyboard: false
        });
    }

    deleteClaimType() {
        const selectedClaimType = this.claimTypeData.find(claimType => claimType.selected);
        let claimTypeId = selectedClaimType ? selectedClaimType.claimTypeId : -1;

        if (this.transactionInfo.isTravelProduct() && this.selectedClaimCode) {
            const claimTypeMapping: Record<string, number> = {
                [ClaimTypes[ClaimTypes.CLAIM_TYPE_TDEL]]: 10, // reroute
                [ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_RROUT]]: 0, // delayed
                [ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN]]: 8, // curtailment
                [ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_CRTL]]: 6 // cancellation
            };
            claimTypeId = claimTypeMapping[this.selectedClaimCode];
        }

        this.claimTypeItemHelperService.deleteClaimType(claimTypeId);
        this.deleteClaimTypeModalRef.close();
    }

    cancelDeleteClaimType() {
        this.chooseIndex = undefined;
        this.selectedClaimCode = '';
        this.hasActiveClaimType = true;
        this.deleteClaimTypeModalRef.close();
    }

    //START - Google Analytics
    pushGASelectClaimView() {
        let ecommerce: any;
        if (!this.transactionInfo.isHomeProduct()) {
            let step = this.transactionInfo.isAccidentProduct() ? 5 : 4;
            ecommerce = {'checkout': {'actionField': {'step': step}}};
        }

        (<any>window).dataLayer = (<any>window).dataLayer || [];
        (<any>window).dataLayer.push({
            'pageStep': 'Select Claim Type',
            'vPath': '/select-claim-type',
            'event': 'vpageview',
            'ecommerce': ecommerce

        });
    }

    pushGASelectClaimOthers() {
        (<any>window).dataLayer = (<any>window).dataLayer || [];
        (<any>window).dataLayer.push({'event': 'otherclaimtypes'});
    }

    //END - Google Analytics

    setGAClaimType(claimType: ClaimTypeItem) {
        this.transactionInfo.setGaPageStep(claimType.gaPageStep);
        this.transactionInfo.setGaVPath(claimType.gaVPath);
    }

    onConfirmECFormSelection(claimTypeItem) {
        this.toggleActive(claimTypeItem.claimTypeId, claimTypeItem);
        this.goToNext();
    }
}
